export default __webpack_public_path__ + "static/media/D1.7ad07448.mp3";